<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          style="border-radius: 17px"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.bBankAccounts.noBankAccts") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center showAllContainer">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.966"
                      height="21.393"
                      viewBox="0 0 20.966 21.393"
                    >
                      <g id="surface1" transform="translate(-0.089 -0.001)">
                        <path
                          id="Path_2471"
                          data-name="Path 2471"
                          d="M.482,5.91a.866.866,0,0,0-.014.128v.88a.872.872,0,0,0,.566.814V9.028a.814.814,0,0,0,.775.81v7.481a.814.814,0,0,0-.775.81V19.42a.882.882,0,0,0-.566.822V21.1a.291.291,0,0,0,.291.291H20.37a.291.291,0,0,0,.291-.291v-.861a.882.882,0,0,0-.566-.822v-1.3a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.733a.873.873,0,0,0,.566-.814V6.044a.845.845,0,0,0-.014-.128.289.289,0,0,0,.235-.529L10.7.035a.291.291,0,0,0-.271,0L.244,5.381a.291.291,0,0,0,.238.529ZM1.617,8.237V7.789H4.97v.444Zm7.467,1.6v7.479a.814.814,0,0,0-.775.81v1.237H5.548V18.129a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.789H8.3V9.026a.814.814,0,0,0,.776.812Zm-.194-1.6V7.789h3.354v.444Zm7.468,1.6v7.479a.814.814,0,0,0-.776.81v1.237h-2.76V18.129a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.789h2.757V9.026a.814.814,0,0,0,.775.812Zm-.194-1.6V7.789h3.354v.444Zm3.354,10.686v.444H16.16v-.444Zm-7.274,0v.444H8.886v-.444ZM9.371,9.262H9.119a.233.233,0,0,1-.233-.233V8.818H12.24V9.03a.233.233,0,0,1-.233.233Zm2.1.582v7.471h-1.8V9.844ZM9.371,17.9h2.637a.233.233,0,0,1,.233.233v.211H8.886v-.211a.233.233,0,0,1,.233-.233Zm-4.4,1.026v.444H1.613v-.444ZM1.613,9.035V8.818H4.966V9.03a.233.233,0,0,1-.233.233H1.839a.233.233,0,0,1-.227-.235Zm2.578.814v7.466h-1.8V9.844ZM1.613,18.135a.233.233,0,0,1,.233-.233H4.734a.233.233,0,0,1,.233.233v.211H1.613ZM20.08,20.254v.57H1.047v-.57a.3.3,0,0,1,.3-.3H19.779a.3.3,0,0,1,.3.295Zm-.566-2.119v.211H16.16v-.211a.233.233,0,0,1,.233-.233h2.894a.233.233,0,0,1,.227.227Zm-2.578-.814V9.844h1.8v7.471Zm2.578-8.285a.233.233,0,0,1-.233.233H16.394a.233.233,0,0,1-.233-.233V8.818h3.354ZM10.563.616l8.66,4.552H1.9ZM1.047,6.044a.291.291,0,0,1,.291-.291H19.789a.291.291,0,0,1,.291.291v.88a.291.291,0,0,1-.291.291H1.337a.291.291,0,0,1-.291-.291Zm0,0"
                          transform="translate(0)"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ bankCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3"
          style="border-radius: 22px"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div
                class="input__group__block"
                style="width: 80%; margin: 0 auto"
              >
                <label class="required primary-color" style="color: white">
                  <span> {{ $t("text.bBankAccounts.addBank") }} </span>
                </label>
                <!-- <details class="input__block position-relative">
                    <summary class="dropdown-info p-3">Select bank accounts to add</summary>
                    <div class="summary-content">
                        <div class="empty-info-wrapper new-row " v-if="!companyBanks ">
                          <img src="@/assets/img/bank-building (2) (2).svg" width="50" />
                          <p class="light-grey-text mt-5">Your company currently doesn't have any bank accounts</p>
                          <small class="light-grey-text">Bank accounts will be displayed when added</small>
                      </div>
                      <ul>
                        <li v-for="(bank,i) in companyBanks" :key="i"  class="cursor-pointer">
                          
                          <input type="checkbox"  class="mr-3"  v-model="bank.checked" :checked="bank.checked"  @change="selectBank($event,bank,i)" :id="`chckBx_${i}`" />
                          <label :for="`chckBx_${i}`"> {{bank.name}}({{bank.accountNumber}})</label>
                        </li>
                      </ul>
                    </div>
                  </details> -->
                <div class="row">
                  <div class="col-md-8">
                    <multiselect
                      v-model="bankValues"
                      tag-placeholder="Add this as new account"
                      placeholder="Search or add an account"
                      label="bankLabel"
                      track-by="id"
                      :options="companyBanks"
                      :multiple="true"
                      :taggable="true"
                    ></multiselect>
                  </div>
                  <div class="col-md-4">
                    <button class="ep-btn ep-primary" @click="addBankAccount">
                      {{ $t("text.bBankAccounts.save") }}
                      <img
                        src="@/assets/img/git_loader.gif"
                        style="display: none"
                        width="35px"
                        class="ml-3 loader"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="products_summary__wrapper mt-3 pb-3">
        <div class="">
          <div class="ep-card green-color p-1 text-center br-5">
            <p class="m-0 primary-color">
              <span class="mr-3">
                <img src="@/assets/img/link.svg" width="25" />
              </span>
              {{ $t("text.bBankAccounts.iconLinked") }}
            </p>
          </div>
        </div>
        <div class="row ml-2">
          <!-- <div class="col-md-4" v-for="(acc) in banks" :key="acc.id">
                <div class="linked-account-wrapper">
                    <div class="linked-acounts-container position-relative">
                        <div class="position-absolute">
                            <div class="linked-icon-container" v-if="acc.linked">
                                <img src="@/assets/img/link.svg" width="25"  />
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-5 pt-3">
                            <span class="font-600 primary-color">
                                {{acc.name}}
                            </span>
                            <p class="primary-color m-0 font-600">{{acc.accountName}}</p>
                        </div>
                        <div class="d-flex justify-content-between mt-4">
                          <p class="font-600 primary-color">{{acc.accountNumber}}</p>
                        </div>
                    </div>
                </div>
            </div> -->
          <div class="col-md-4" v-for="acc in banksArr" :key="acc.id">
            <div class="linked-account-wrapper">
              <div class="linked-acounts-container position-relative">
                <div class="position-absolute">
                  <div class="linked-icon-container" v-if="acc.linked">
                    <img src="@/assets/img/link.svg" width="25" />
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center mt-5 pt-3"
                >
                  <div>
                    <span class="font-600 primary-color" v-if="!acc.iconUrl">
                      {{ acc.name }}
                    </span>
                    <img
                      :src="`${
                        acc.iconUrl
                          ? acc.iconUrl
                          : require('@/assets/img/bank-building (2).svg')
                      }`"
                      width="40"
                      v-if="acc.iconUrl"
                    />
                  </div>
                  <p class="primary-color m-0 font-600">
                    {{ acc.accountName }}
                  </p>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <p class="font-600 primary-color">{{ acc.accountNumber }}</p>
                  <h6
                    class="color-red font-600 cursor-pointer"
                    @click="removeBank(acc)"
                  >
                    {{ $t("text.bBankAccounts.removeBank") }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="">
              <div class="linked-account-muted">
                <div class="mx-auto text-center">
                  <img src="@/assets/img/bank-disabled.svg" width="25" />
                  <p class="text-muted mt-3">
                    {{ $t("text.bBankAccounts.accountAddShow") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- <section class="products_summary__wrapper  pb-3" v-if="bankCount < 1 && !showLoader">
              <div class="empty_tank_wrapper" style="height: 400px;background: white; display: flex; justify-content: center; align-items: center; flex-flow: column wrap">
              
              <div class="text-center"   style="margin-top: 60px">
                  <h3 style="color: rgb(161, 146, 146); font-size: 25px;">{{$t('text.bBankAccounts.emptyBankRecord')}}</h3>
              </div>

              <div class="text-center mt-5">
                  <img src="@/assets/img/target (1) (1).svg"  width="100"  />
              </div>

              <div class="text-cente pb-5" style="margin-top: 50px">
                  <h3  style="color: rgb(161, 146, 146); font-size: 25px;">You currently don't have any target record</h3>
              </div>
              </div>
      </section> -->
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import Multiselect from "vue-multiselect";

import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "BankAccounts",
  components: {
    MasterLayout,
    Multiselect,
  },
  data() {
    return {
      banks: [],
      bankNames: [],
      branch: {},
      branchId: null,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      showLinkedBanks: false,
      bankCount: 0,
      bankName: "",
      accountNumber: "",
      isButtonDisabled: false,
      accountName: "",
      selectedBanksArray: [],
      bankValues: [],
      companyBanks: [],
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      bankList: [],
      banksArr: [],
    };
  },
  created() {
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Bank Accounts :: ${branch.name} Retail Outlet`;
    });
    document.title = `Bank Accounts :: Epump Retail Outlet`;
    this.getBankList();
  },
  computed: {
    linkedBanks() {
      return this.banks.filter((bank) => bank.linked === true);
    },
  },
  computed: {
    linkedBanks() {
      return this.banks.filter((bank) => bank.linked === true);
    },
  },
  watch: {
    bankValues: {
      handler(val) {},
      deep: true,
    },
    banks() {
      const bankList = [...this.bankList];
      this.banks.forEach((bank) => {
        const bankIndex = this.bankList.findIndex(
          (bl) => bl.bankName === bank.name
        );
        if (bankIndex > -1) {
          bank.iconUrl = this.bankList[bankIndex].iconUrl;
        } else if (bank.name == "GTBank") {
          const bankObj = this.bankList.filter(
            (bl) => bl.bankName == "Gtbank Plc"
          )[0];
          bank.iconUrl = bankObj.iconUrl;
        } else {
          bank.iconUrl = null;
        }
      });
      this.banksArr = this.banks;
    },
    banks() {
      const bankList = [...this.bankList];
      this.banks.forEach((bank) => {
        const bankIndex = this.bankList.findIndex(
          (bl) => bl.bankName === bank.name
        );
        if (bankIndex > -1) {
          bank.iconUrl = this.bankList[bankIndex].iconUrl;
        } else if (bank.name == "GTBank") {
          const bankObj = this.bankList.filter(
            (bl) => bl.bankName == "Gtbank Plc"
          )[0];
          bank.iconUrl = bankObj.iconUrl;
        } else {
          bank.iconUrl = null;
        }
      });
      this.banksArr = this.banks;
    },
    companyBanks() {
      this.getBranchBankAccts();
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getCompanyBankAccounts();
          this.$eventHub.$on("branch", (branch) => {
            this.branch = branch;
          });
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
        }
      }
    },
  },
  mounted() {
    this.getBanks();
  },
  methods: {
    selectBank($event, index) {
      this.companyBanks.forEach((cBank, cId) => {
        if (index === cId) {
          if ($event.target.checked) {
            cBank.checked = true;
          }
        }
      });
    },
    addBankAccount() {
      const accountIds = this.bankValues.map((selBank) => {
        return selBank.id;
      });
      if (accountIds.length === 0) {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.selectAccountError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      const data = {
        branchId: this.branchId,
        accountIds: accountIds,
      };

      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/AddBankAccount`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.getBranchBankAccts();
          this.$toast.open({
            message: this.$t("text.bBankAccounts.bankAdded"),
            type: "success",
            duration: 5000,
          });
        })
        .catch((error) => {
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    getBankList() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Utilities/BankList?ApplyPaging=false`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankList = response.data.data;
        })
        .catch((error) => {});
    },
    // getBankList() {
    //   this.axios
    //       .get(
    //       `${configObject.apiBaseUrl}/Utilities/BankList?ApplyPaging=false`,
    //       configObject.authConfig()
    //       )
    //       .then(response => {
    //           this.bankList = response.data.data;
    //       })
    //       .catch(error => {

    //       });
    // },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Banks?companyId=${this.branch.companyId}&branchId=${this.branch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankNames = response.data;
        })
        .catch((error) => {});
    },
    captureFormEvents($event) {
      if (
        $event.target.placeholder ===
        this.$t("text.bBankAccounts.inputAccountName")
      ) {
        if ($event.target.value === "") {
          this.$refs.account_name_error.style.display = "block";
          this.$refs.account_name_error.innerHTML = this.$t(
            "text.errors.accountNameMissing"
          );
          this.$refs.account_name_input_div.style.border = "1px solid red";
          this.$refs.account_name_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.account_name_error.style.display = "none";
          this.$refs.account_name_error.innerHTML = "";
          this.$refs.account_name_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = false;
        }
      }
      if (
        $event.target.placeholder ===
        this.$t("text.bBankAccounts.inputAccountNumber")
      ) {
        if ($event.target.value === "") {
          this.$refs.account_number_error.style.display = "block";
          this.$refs.account_number_error.innerHTML = this.$t(
            "text.errors.accountNumberMissing"
          );
          this.$refs.account_number_input_div.style.border = "1px solid red";
          this.$refs.account_number_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.account_number_error.style.display = "none";
          this.$refs.account_number_error.innerHTML = "";
          this.$refs.account_number_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = false;
        }
      }
    },
    getCompanyBankAccounts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/BankAccounts/${this.$route.query.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((el) => {
            el.bankLabel = `${el.name}(${el.accountName} ${el.accountNumber})`;
            el.checked = false;
          });
          this.companyBanks = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getBranchBankAccts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankAccounts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.iconUrl = "";
            const nameArr = el.accountName.split(" ");
            if (nameArr.length > 1) {
              el.accountName = `${nameArr[0]}.${nameArr[1].charAt(0)}`;
            }
          });
          this.showLoader = false;
          this.showLinkedBanks = true;
          this.banks = response.data;
          // response.data.forEach(el => {
          //   el.bankLabel = `${el.name}(${el.accountName})`
          //   const nameArr = el.accountName.split(' ')
          //     if(nameArr.length > 1) {
          //       el.accountName = `${nameArr[0]}.${nameArr[1].charAt(0)}`
          //     }
          // })
          // this.showLoader = false
          // this.banks = response.data;
          // this.bankValues = this.banks
          // this.bankCount = response.data.length;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    addBankAccts() {
      if (!this.bankName) {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.selectBankError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.accountNumber) {
        this.$toast.open({
          message: this.$t("text.errors.accountNumberMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.accountName) {
        this.$toast.open({
          message: this.$t("text.errors.accountNameMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      $(".loader").show();
      let data = {
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        branchId: this.branchId,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/AddBankAccount`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.getCompanyBankAccounts();
          this.$toast.open({
            message: this.$t("text.bBankAccounts.bankAdded"),
            type: "error",
            type: "success",
            duration: 5000,
          });
          this.getBranchBankAccts();
        })
        .catch((error) => {});
    },
    deleteBankAcct(id) {
      const remove = confirm(this.$t("text.bBankAccounts.confirmDelete"));
      if (!remove) {
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RemoveBankAccount/${id}?branchId=${this.branchId}`,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.bBankAccounts.successfullyDeleted"),
            type: "success",
            duration: 5000,
          });
          this.getCompanyBankAccounts();
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.bBankAccounts.unsuccessfulDelete"),
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
